import type { IconSvgObject } from './types';

const LocationUser04Icon: IconSvgObject = [
  ["path", { d: "M7 14H9L10.5 19H13.5L15 14H17V12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12V14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "4.5", r: "2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.5 17.5L19.875 20.5939C20.169 21.2551 19.6849 22 18.9612 22H4.97681C4.2694 22 3.78565 21.2856 4.04828 20.6287L5.49918 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LocationUser04Icon;
